import { render, staticRenderFns } from "./ClientEntityDetails.vue?vue&type=template&id=1d44dad4&"
import script from "./ClientEntityDetails.vue?vue&type=script&lang=js&"
export * from "./ClientEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d44dad4')) {
      api.createRecord('1d44dad4', component.options)
    } else {
      api.reload('1d44dad4', component.options)
    }
    module.hot.accept("./ClientEntityDetails.vue?vue&type=template&id=1d44dad4&", function () {
      api.rerender('1d44dad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClientEntityDetails.vue"
export default component.exports